import type React from 'react'

import styled from 'styled-components'

import type { DeviceSpecificValue } from './lib/type'

interface GalleryProps {
  $columns: DeviceSpecificValue
  $firstImageFullWidth?: boolean
  $gaps: DeviceSpecificValue
  children: React.ReactNode
}

const Gallery = styled.div<GalleryProps>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.$columns.mobile}, 1fr);
    gap: ${(props) => props.$gaps.mobile}px;

    @media (min-width: 480px) {
        grid-template-columns: repeat(${(props) => props.$columns.tablet}, 1fr);
        gap: ${(props) => props.$gaps.tablet}px;
    }

    @media (min-width: 768px) {
        grid-template-columns: repeat(${(props) => props.$columns.desktop}, 1fr);
        gap: ${(props) => props.$gaps.desktop}px;
    }

    ${(props) =>
      props.$firstImageFullWidth &&
      `
        & > :first-child {
            grid-column: 1 / -1;
        }
    `}
`

const GalleryGrid: React.FC<GalleryProps> = ({
  $columns,
  $firstImageFullWidth,
  $gaps,
  children,
}) => {
  return (
    <Gallery
      $columns={$columns}
      $firstImageFullWidth={$firstImageFullWidth}
      $gaps={$gaps}
    >
      {children}
    </Gallery>
  )
}

export default GalleryGrid
